import useTranslation from 'next-translate/useTranslation'
import { useState } from 'react'
import { twMerge } from 'tailwind-merge'

import { truncateString } from '@unreserved-frontend-v2/utils/truncate-string'

import { RestrictableContent } from '../utils/types'

export type DetailsDescriptionProps = RestrictableContent & {
  className?: string
  containerClassName?: string
  description?: string
  isOpen?: boolean
  maxLength?: number
  showViewLessCta?: boolean
}

export const DetailsDescription = ({
  isRestricted,
  description,
  className,
  containerClassName,
  isOpen,
  maxLength = 340,
  showViewLessCta,
}: DetailsDescriptionProps) => {
  const { t } = useTranslation()
  const [isFullDescription, setIsFullDescription] = useState(
    isOpen || (!!description && description?.length <= maxLength)
  )
  const descriptionClass = twMerge(className, isRestricted ? 'blur-sm select-none' : '')

  return description ? (
    <details className={twMerge('[&[open]>summary]:hidden', containerClassName)} open={isFullDescription}>
      <summary
        className="list-none [&::-webkit-details-marker]:hidden"
        // When JS is enabled, defer opening state to show more button only
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
        data-nosnippet={true}
      >
        <p className={descriptionClass}>
          <span>
            {truncateString(description, maxLength)}{' '}
            {!isRestricted ? (
              <span
                className="cursor-pointer font-semibold text-primary underline"
                onClick={() => {
                  setIsFullDescription(true)
                }}
              >
                {t('listings:details-pages.show-more')}
              </span>
            ) : null}
          </span>
        </p>
      </summary>
      <p data-nosnippet={isRestricted} className={descriptionClass}>
        {description}
        {showViewLessCta && description?.length > maxLength ? (
          <span>
            {' '}
            {!isRestricted ? (
              <span
                className="cursor-pointer font-semibold text-primary underline"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  setIsFullDescription(false)
                }}
              >
                {t('listings:details-pages.show-less')}
              </span>
            ) : null}
          </span>
        ) : null}
      </p>
    </details>
  ) : null
}
